import React, { useState, useMemo, useEffect } from 'react';
import { useQuery } from "@tanstack/react-query";
import { Modal, Row, Col, Card, Placeholder } from 'react-bootstrap';
import { ProductApi } from '../../app/api/product.api';
import productData from './productData';


const currencies = ['FCFA'];


export function ProductCard ({ product, onEdit, detail }) 
{
  const dateChecker = useMemo(() => {
    if (!product?.updatedAt) return false;

    const productDate = new Date(product.updatedAt);
    const now = new Date();
    const diffInMs = now - productDate;
    const diffInDays = diffInMs / (1000 * 60 * 60 * 24);

    return diffInDays <= 5;
  }, [product]);  

  return (

    <div className="col-xl-4 col-lg-6 col-md-6 col-sm-6 mb-4">
      <div className="product-card border d-flex p-0 flex-column">
        {/* Badge Diagonale (New/Sale) */}
        { dateChecker && (
          <div className={`badge-corner new`}>
            <span> New </span>
          </div>
        )}
        {/* Image & Overlay Actions au Hover */}
        <div className="product-image-wrapper">
          <img src={ product?.images[0]?.url } alt={product?.name} className="img-fluid" />
        </div>
        {/* Infos Produit */}
        <div className="product-info mb-3 px-3">
          <div className="d-flex justify-content-between align-items-start">
            <div>
              <div className="d-flex align-items-center">
                <h6 className="product-name text-truncate" style={{maxWidth: '150px'}}>
                  {product.name}
                </h6>
              </div>
              
               <div className="stars">
                {[...Array(product?.starCount)].map((_, i) => (
                  <i key={i} className="bi bi-star-fill me-1"></i>
                ))}
              </div>

              <div className="d-flex gap-3 align-items-center">
                <span className="price-current"> { product?.price + " " + product?.currency } </span>
                {
                 ! product?.isVisible && ( <div className="text-danger small"> <i className="bi bi-x-circle" title='Produit bloqué' ></i> </div> )
                }
              </div>

              <div className="d-flex gap-3 align-items-center">
                <button title="Plus d'informations" className="btn btn-sm rounded-0 btn-outline-green px-3 mt-2" onClick={ detail }>
                   Details <i className="bi bi-chevron-right"></i> 
                </button>
                <button title="Modifier le produit" className="btn btn-sm rounded-0 btn-outline-green px-3 mt-2" onClick={() => onEdit(product)}>
                 Modifier <i className="bi bi-pencil"> </i> 
                </button>
              </div>

            </div>
            
          </div>
        </div>
      </div>
    </div>
  );
};


// Modal pour Ajouter un Nouveau Produit
export function AddProductModal({ show, onHide, refetch }) 
{

  const product = ProductApi('multipart/form-data');
  
  const [status, setStatus] = useState(0);
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [inputs, setInputs] = useState({
    name: '',
    description: '',
    price: '',
    currency: 'FCFA',
    category: '',
    subcategory: '',
    video: '',
    starCount: 5,
  });

  const [images, setImages] = useState([]);
  const [previews, setPreviews] = useState([]);
  const [listSubcategories, setlistSubcategories] = useState([]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    // Mise à jour du formulaire
    setInputs((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Si category change → mettre à jour les sous-catégories
    if (name === "category") {
      const selectedCategory = productData.subcategories.find((item) => item.category === value );
      setlistSubcategories( selectedCategory ? selectedCategory.listItems : [] );
    }
  };

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    
    // Vérifier le maximum de 5 images
    if (files.length + images.length > 5) {
      alert('Vous pouvez sélectionner maximum 5 images');
      return;
    }

    setImages([...images, ...files]);

    // Créer les aperçus
    files.forEach((file) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviews((prev) => [...prev, reader.result]);
      };
      reader.readAsDataURL(file);
    });
  };

  const removeImage = (index) => {
    setImages(images.filter((_, i) => i !== index));
    setPreviews(previews.filter((_, i) => i !== index));
  };


  const handleSubmit = async (event) => {
    event.preventDefault();

    setStatus(0);
    setIsLoading(true);

    try {
      const formData = new FormData();

     // Champs texte
     formData.append('name', inputs.name);
     formData.append('description', inputs.description);
     formData.append('price', inputs.price);
     formData.append('currency', inputs.currency);
     formData.append('category', inputs.category);
     formData.append('subcategory', inputs.subcategory);
     formData.append('video', inputs.video);
     formData.append('starCount', inputs.starCount);

     //  Images (important)
     if (images && images.length > 0) {
       images.forEach((image) => {
         formData.append('images', image); 
       });
     }

     const { data } = await product.insert(formData);
     console.log(data)

     if (data.success) {
       setStatus(1);
       setMessage(data.message);
       handleReset();
       refetch();
     } else {
       setStatus(-1);
       setMessage('Erreur, veuillez réessayer');
     }

    } catch (err) {
      setStatus(-1);
      const response = err?.response?.data;
      console.log(response)

      if (response?.message) {
        setMessage(response.message);
      } else if (Array.isArray(response?.errors) && response.errors.length > 0) {
        setMessage(response.errors[0].message || response.errors[0]);
      } else {
        setMessage("Une erreur est survenue. Veuillez réessayer.");
      }
    } finally {
      setIsLoading(false);
    }
  };


  const handleReset = () => {
    setInputs({
      name: '',
      description: '',
      price: '',
      currency: 'FCFA',
      category: 'biomedicale',
      subcategory: 'Équipements médicaux',
      video: '',
      starCount: 5,
    });
    setImages([]);
    setPreviews([]);
  };

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
    <form onSubmit={handleSubmit} encType="multipart/form-data">

      <Modal.Header closeButton>
        <Modal.Title className='fs-4 text-green px-4'>
          <i className="bi bi-plus-circle me-2"></i>
          Nouveau produit
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className='row justify-content-center p-4'>
        <div className='col-md-11' >
          
          {/* Catégorie et Sous-catégorie */}
          <div className="row">
          {
            isLoading && (
              <div className="d-flex justify-content-center mb-2"> 
                <div className="spinner-border text-green" role="status" aria-label="Chargement"></div>
              </div>
            )
          }
          {
            status === 1 && (
              <div className="alert alert-success mb-2 w-100 small"> { message } </div>
            )
          }
          {
            status === -1 && (
              <div className="alert alert-danger mb-2 w-100 small"> { message } </div>
            )
          }
            {/* Nom */}
            <div className=" col-md-8 mb-2">
              <label className="small text-secondary mb-1">Nom du Produit</label>
              <input 
                type="text"
                name="name"
                className='border w-100 p-2 text-muted '
                value={inputs.name}
                onChange={handleInputChange}
                placeholder="Entrez le nom du produit"
                required
              />
            </div>
            {/* Note/Rate */}
            <div className="col-md-4 mb-2">
              <label className="small text-secondary mb-1">Note (de 1 à 5)</label>
              <input
                type="number"
                name="starCount"
                className='border w-100 p-2 text-muted '
                value={inputs.starCount}
                onChange={handleInputChange}
                min="1"
                max="5"
                step="1"
                required
              />
            </div>
          </div>

          {/* Description */}
          <div className="mb-2">
            <label className="small text-secondary mb-1">Description</label>
            <textarea
              className='border w-100 p-2 text-muted '
              rows={3}
              name="description"
              value={inputs.description}
              onChange={handleInputChange}
              placeholder="Entrez la description du produit"
              required
            />
          </div>

          {/* Images */}
          <div className="d-flex flex-column mb-2">
            <label className="small text-secondary mb-1">Images (Max 5)</label>
            <input
              className='border w-100 p-2 text-muted '
              type="file"
              name='images'
              multiple
              accept="image/*"
              onChange={handleImageChange}
              required
            />
            {previews.length > 0 && (
              <div className="mt-3">
                <div className="d-flex gap-3 flex-wrap">
                  {previews.map((preview, index) => (
                    <div key={index} className="position-relative">
                      <img className='border border-3'
                        src={preview}
                        alt={`Preview ${index}`}
                        style={{
                          width: '80px',
                          height: '80px',
                          objectFit: 'cover',
                          borderRadius: '6px',
                        }}
                      />
                      <button
                        type="button"
                        className="btn btn-sm btn-danger position-absolute top-0 end-0"
                        onClick={() => removeImage(index)}
                        style={{ transform: 'translate(50%, -50%)' }}
                      >
                        ✕
                      </button>
                    </div>
                  ))}
                </div>
                <small className="text-muted d-block mt-2">
                  {previews.length}/5 images sélectionnées
                </small>
              </div>
            )}
          </div>

          {/* Prix et Devise */}
          <div className="row">
            <div className="col-md-6 mb-2">
              <label className="small text-secondary mb-1">Prix</label>
              <input
                type="number"
                name="price"
                className='border w-100 p-2 text-muted '
                value={inputs.price}
                onChange={handleInputChange}
                placeholder="Entrez le prix"
                step="0.01"
                required
              />
            </div>

            <div className="col-md-6 mb-2">
              <label className="small text-secondary mb-1">Devise</label>
              <select
                name="currency"
                className='border w-100 p-2 text-muted '
                value={inputs.currency}
                onChange={handleInputChange}
                required
              >
                <option value="" > Sélectionner une devise </option>
                {currencies.map((curr) => (
                  <option key={curr} value={curr}>
                    {curr}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {/* Catégorie et Sous-catégorie */}
          <div className="row">
            <div className="col-md-6 mb-2">
              <label className="small text-secondary mb-1">Catégorie</label>
              <select
                name="category"
                className='border w-100 p-2 text-muted '
                value={inputs.category}
                onChange={handleInputChange}
                required
              >
                <option value="" > Sélectionner une catégorie </option>
                {
                  productData.categories.map((item, index)=> ( 
                    <option value={item.name} key={index}> {item.content} </option> 
                  ))
                }
              </select>
            </div>

            <div className="col-md-6 mb-2">
              <label className="small text-secondary mb-1">Sous-catégorie</label>
              <select
                name="subcategory"
                className='border w-100 p-2 text-muted '
                value={inputs.subcategory}
                onChange={handleInputChange}
                required
              >
                <option value="" > Sélectionner une sous catégorie </option>
                {
                  listSubcategories.map((item, index)=> ( 
                    <option value={item.name} key={index}> {item.content} </option> 
                  ))
                }
              </select>
            </div>
          </div>

          {/* Vidéo */}
          <div className="mb-2">
            <label className="small text-secondary mb-1">Lien Vidéo (URL)</label>
            <input
              type="url"
              name="video"
              className='border w-100 p-2 text-muted '
              value={inputs.video}
              onChange={handleInputChange}
              placeholder="https://example.com/video"
            />
          </div>

        </div>
      </Modal.Body>
      <Modal.Footer className='gap-3 pb-3'>
        <button className='btn btn-sm btn-outline-danger px-3' onClick={() => { handleReset(); onHide(); }}>
          Annuler
        </button>
        <button className='btn btn-sm btn-green px-3'>
          <i className="bi bi-check-circle me-2"></i>
          Enregistrer
        </button>
      </Modal.Footer>

    </form>
    </Modal>
  );
}


// Modal pour Modifier un Produit
export function EditProductModal({ show, onHide, product, refetch }) 
{

  const products = ProductApi();

  const [status, setStatus] = useState(0);
  const [message, setMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const [formData, setFormData] = useState({
    name: product?.name || '',
    description: product?.description || '',
    price: product?.price || '',
    currency: product?.currency || 'FCFA',
    category: product?.category || '',
    subcategory: product?.subcategory || '',
    video: product?.video || '',
    starCount: product?.starCount || 5,
    isVisible: product?.isVisible || true,
  });

  const [productImages, setProductImages] = useState(product?.images || []);
  const [listSubcategories, setlistSubcategories] = useState([]);

  useEffect(() => {
    if (product && show) {
      setFormData({
        name: product.name || '',
        description: product.description || '',
        price: product.price || '',
        currency: product.currency || 'FCFA',
        category: product.category || '',
        subcategory: product.subcategory || '',
        video: product.video || '',
        starCount: product.starCount || 5,
        isVisible: product.isVisible ?? true,
      });

      setProductImages(product.images || []);

      const selectedCategory = productData.subcategories.find((item) => item.category === product.category );
      setlistSubcategories( selectedCategory ? selectedCategory.listItems : [] );
    }
  }, [product, show]);


  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: name === "isVisible" ? value === "true" : value,
    }));

    // Si category change → mettre à jour les sous-catégories
    if (name === "category") {
      const selectedCategory = productData.subcategories.find((item) => item.category === value );
      setlistSubcategories( selectedCategory ? selectedCategory.listItems : [] );
    }
  };


  const handleSubmit = async (e) => {
  e.preventDefault();

  setIsLoading(true);
  setStatus(0);

  try {
    const dataToSend = new FormData();

    dataToSend.append('name', formData.name);
    dataToSend.append('description', formData.description);
    dataToSend.append('price', formData.price);
    dataToSend.append('currency', formData.currency);
    dataToSend.append('category', formData.category);
    dataToSend.append('subcategory', formData.subcategory);
    dataToSend.append('video', formData.video);
    dataToSend.append('starCount', formData.starCount);
    dataToSend.append('isVisible', formData.isVisible);

    const { data } = await products.update(product.id, dataToSend);

    if (data.success) {
      setStatus(1);
      setMessage(data.message);
      refetch();
    } else {
      setStatus(-1);
      setMessage("Erreur lors de la mise à jour");
    }

  } catch (err) {
      setStatus(-1);
      const response = err?.response?.data;

      if (response?.message) {
        setMessage(response.message);
      } else if (Array.isArray(response?.errors) && response.errors.length > 0) {
        setMessage(response.errors[0].message || response.errors[0]);
      } else {
        setMessage("Une erreur est survenue. Veuillez réessayer.");
      }
  } finally {
    setIsLoading(false);
  }
};


  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
    <form onSubmit={handleSubmit}>
      <Modal.Header closeButton>
        <Modal.Title className='fs-4 text-green px-4'>
          <i className="bi bi-pencil me-2"></i>
          Modifier le Produit
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className='row justify-content-center p-4'>
        <div className='col-md-11'>
          {/* Catégorie et Sous-catégorie */}
          <div className="row">
            {
            isLoading && (
              <div className="d-flex justify-content-center mb-2"> 
                <div className="spinner-border text-green" role="status" aria-label="Chargement"></div>
              </div>
            )
          }
          {
            status === 1 && (
              <div className="alert alert-success mb-2 w-100 small"> { message } </div>
            )
          }
          {
            status === -1 && (
              <div className="alert alert-danger mb-2 w-100 small"> { message } </div>
            )
          }
            {/* Nom */}
            <div className=" col-md-8 mb-2">
              <label className="small text-secondary mb-1">Nom du Produit</label>
              <input 
                type="text"
                name="name"
                className='border w-100 p-2 text-muted '
                value={formData.name}
                onChange={handleInputChange}
                placeholder="Entrez le nom du produit"
                required
              />
            </div>
            {/* Note/Rate */}
            <div className="col-md-4 mb-2">
              <label className="small text-secondary mb-1">Note (de 1 à 5)</label>
              <input
                type="number"
                name="starCount"
                className='border w-100 p-2 text-muted '
                value={formData.starCount}
                onChange={handleInputChange}
                min="1"
                max="5"
                step="1"
                required
              />
            </div>
          </div>

           {/* Description */}
          <div className="mb-2">
            <label className="small text-secondary mb-1">Description</label>
            <textarea
              className='border w-100 p-2 text-muted '
              rows={3}
              name="description"
              value={formData.description}
              onChange={handleInputChange}
              placeholder="Entrez la description du produit"
              required
            />
          </div>

          {/* Aperçu des Images */}
          <div className="mb-3 border p-3">
            <label className="text-green">Images du produits </label>
            {productImages.length > 0 ? (
              <div className="d-flex gap-2 flex-wrap">
                {productImages.map((image, index) => (
                  <div key={index} className="position-relative">
                    <img className='border border-3'
                      src={image?.url}
                      alt={`Product ${index}`}
                      style={{
                        width: '80px',
                        height: '80px',
                        objectFit: 'cover',
                        borderRadius: '6px',
                      }}
                    />
                  </div>
                ))}
              </div>
            ) : (
              <p className="text-muted">Aucune image disponible</p>
            )}
          </div>
        
           {/* Prix et Devise */}
          <div className="row">
            <div className="col-md-6 mb-2">
              <label className="small text-secondary mb-1">Prix</label>
              <input
                type="number"
                name="price"
                className='border w-100 p-2 text-muted '
                value={formData.price}
                onChange={handleInputChange}
                placeholder="Entrez le prix"
                step="0.01"
                required
              />
            </div>

            <div className="col-md-6 mb-2">
              <label className="small text-secondary mb-1">Devise</label>
              <select name="currency" className='border w-100 p-2 text-muted' value={formData.currency} onChange={handleInputChange} required >
                <option value="" > Sélectionner une devise </option>
                {currencies.map((curr) => (
                  <option key={curr} value={curr}>
                    {curr}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {/* Catégorie et Sous-catégorie */}
          <div className="row">
            <div className="col-md-6 mb-2">
              <label className="small text-secondary mb-1">Catégorie</label>
              <select name="category" className='border w-100 p-2 text-muted' value={formData.category} onChange={handleInputChange} required >
                <option value="" > Sélectionner une catégorie </option>
                {
                  productData.categories.map((item, index)=> ( 
                    <option value={item.name} key={index}> {item.content} </option> 
                  ))
                }
              </select>
            </div>

            <div className="col-md-6 mb-2">
              <label className="small text-secondary mb-1">Sous-catégorie</label>
              <select name="subcategory" className='border w-100 p-2 text-muted' value={formData.subcategory} onChange={handleInputChange} required >
                <option value="" > Sélectionner une sous catégorie </option>
                {
                  listSubcategories.map((item, index)=> ( 
                    <option value={item.name} key={index}> {item.content} </option> 
                  ))
                }
              </select>
            </div>
          </div>

          {/* Vidéo */}
          <div className="mb-2">
            <label className="small text-secondary mb-1">Lien Vidéo (URL)</label>
            <input
              type="url"
              name="video"
              className='border w-100 p-2 text-muted '
              value={formData.video}
              onChange={handleInputChange}
              placeholder="https://example.com/video"
              required
            />
          </div>

          {/* Affichage */}
          <div className="mb-2">
            <label className="small text-secondary mb-1"> Statut d'Affichage </label>
            <select
              name="isVisible"
              className='border w-100 p-2 text-muted '
              value={formData.isVisible}
              onChange={handleInputChange}
              required
            >
              <option value="" > Choisir le statut </option>
              <option value={ true } >Publier</option>
              <option value={ false }>Bloquer</option>
            </select>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className='gap-3 pb-3'>
        <button className='btn btn-sm btn-outline-danger px-3' onClick={onHide}>
          Annuler
        </button>
        <button className='btn btn-sm btn-green px-3' onClick={handleSubmit}>
          <i className="bi bi-check-circle me-2"></i>
          Mettre à jour
        </button>
      </Modal.Footer>

    </form>
    </Modal>
  );
}




// Skeleton Loader pour ProductCard
export function ProductCardSkeleton () {

  return (
  <div className="col-xl-3 col-md-6 col-sm-6 col-lg-4 mb-4">
    <div className="product-card border">
      {/* Image Skeleton */}
      <div className="product-image-wrapper">
        <div 
          style={{
            width: '100%',
            paddingBottom: '100%',
            backgroundColor: '#e0e0e0',
            position: 'relative',
            animation: 'pulse 2s ease-in-out infinite'
          }}
        />
      </div>
      {/* Infos Skeleton */}
      <div className="product-info my-3 px-3">
        <div className="d-flex justify-content-between align-items-start">
          <div style={{ width: '100%' }}>
            {/* Titre Skeleton */}
            <div 
              style={{
                height: '16px',
                backgroundColor: '#e0e0e0',
                marginBottom: '10px',
                borderRadius: '4px',
                width: '80%',
                animation: 'pulse 2s ease-in-out infinite'
              }}
            />
            {/* Stars Skeleton */}
            <div 
              style={{
                height: '16px',
                backgroundColor: '#e0e0e0',
                marginBottom: '10px',
                borderRadius: '4px',
                width: '70%',
                animation: 'pulse 2s ease-in-out infinite'
              }}
            />
            {/* Prix Skeleton */}
            <div 
              style={{
                height: '18px',
                backgroundColor: '#e0e0e0',
                marginBottom: '10px',
                borderRadius: '4px',
                width: '50%',
                animation: 'pulse 2s ease-in-out infinite'
              }}
            />
            {/* Bouton Skeleton */}
            <div 
              style={{
                height: '36px',
                backgroundColor: '#e0e0e0',
                marginTop: '8px',
                borderRadius: '4px',
                width: '100%',
                animation: 'pulse 2s ease-in-out infinite'
              }}
            />
          </div>
        </div>
      </div>
    </div>
    <style>{`
      @keyframes pulse {
        0% {
          opacity: 1;
        }
        50% {
          opacity: 0.5;
        }
        100% {
          opacity: 1;
        }
      }
    `}</style>
  </div>
);
}




export function StatContainer()
{
    const product = ProductApi(); 

    const fetchData = async () => { 
      const {data} = await product.getCount();
      return data.data; 
    }
    const { isLoading, data=[], error } = useQuery({  queryKey: ["productStats"], queryFn: fetchData });


    if (isLoading){
      return (
        <Row className="g-4">
        {
          Array.from({ length: 4 }).map((_, index) => (
            <Col key={index} lg={6} md={6} sm={6} xs={12}>
              <Placeholder as="div" animation="glow" className="w-100 bg-secondary bg-opacity-25 rounded" style={{ height: '140px' }} />
            </Col>
          ))
        }
        </Row>
      )
    };
    if (error){
      return(
        <div className="text-center p-4 border alert alert-danger w-100">
          Une erreur est survenue. Vueiller vérifier votre connexion 
        </div>
      )
    }

    return(

      <Row className="mb-5 g-4">
        { 
          data.map((item, index) => (
            <Col key={index} lg={6} md={6} sm={6} xs={12}>
              <Card className="stat-card h-100 rounded-0 border">
                <Card.Body className="text-center">
                  <div className="stat-value text-secondary fs-2 mb-2" > {item.count} </div>
                  <div className="text-secondary">{item.category}</div>
                </Card.Body>
              </Card>
            </Col>
        ))}
      </Row>

    )
}




